module.exports = __webpack_public_path__ + "static/img/qyjr40.fe2e245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyjr40.jpg
// module id = I1Qn
// module chunks = 73